import { AudioManager } from "../../AudioManager";
import { HelpParameters, Help, HelpPanelColor } from "../../help/Help";
import { IHelpFactory } from "../../help/IHelpFactory";
import { MultigameParams } from "../../MultigameParams";
import { SlotGameInitData } from "../../SlotGameInitData";
// import { IPanelFactory, PanelParams } from "../panel/IPanelFactory";
// import { Panel, ButtonColors } from "../panel/panel";
import { RewardColor } from "../ScatterRandomAward/RewardOptionFactory";
import { SlotGameType1_1Screen } from "../SlotGameType1_1Screen";
import { IWinLinesFactory } from "../WinLines/IWinLinesFactory";
import { SquareWinLinesFactory } from "../WinLines/SquareWinLineFactory";
// namespace SlotGames {
    export class SecretsOfAnubis_1Screen extends SlotGameType1_1Screen {
        // override default factory with one that creates custom anubis freegame

        
        protected override helpFactory: IHelpFactory = new SecretsOfAnubisHelpFactory();
        //LED COLOR
		protected override ColorLed:string="205,164,52\n";
        constructor(multigameParams: MultigameParams, initData: SlotGameInitData , gameName : string = "SecretsOfAnubis" ) {
            super(multigameParams, initData, gameName);

            this.spinnableReelsParams.topBorderWidth = 6;
            this.spinnableReelsParams.bottomBorderWidth = 6;
        }


    }

    //Help Colorized
    class SecretsOfAnubisHelpFactory implements IHelpFactory {
        public CreateNewHelp(params: HelpParameters): Help {
            return new SecretsOfAnubisHelp(params);
        }
    }

    class SecretsOfAnubisHelp extends Help {
        protected override BackgroundPanel(): HelpPanelColor {
            let color: HelpPanelColor = {
                backgroundPanelColor: "linear-gradient(rgb(64, 10, 5),rgb(89, 23, 8), rgb(140, 52, 20),rgb(89, 23, 8),rgb(64, 10, 5)), linear-gradient( #BF953F, #FCF6BA, #B38728, #FBF5B7, #AA771C)",
            };

            return color;
        }
    }

// }



